import { NextRouter, useRouter } from 'next/router'
import { useEffect } from 'react'
import ReactGA from 'react-ga4'

let MEASUREMENT_ID = null

type ga4_event = {
  category: string
  action: string
}

const GA4_BUTTON_CLICK: ga4_event = {
  category: 'button',
  action: 'click',
}
const GA4_LINK_CLICK: ga4_event = {
  category: 'link',
  action: 'click',
}

const GA4_CARD_CLICK: ga4_event = {
  category: 'card',
  action: 'click',
}

const GA4_INPUT_CHANGE: ga4_event = {
  category: 'input',
  action: 'change',
}

export const ga4_initialize = (measurementId) => {
  MEASUREMENT_ID = measurementId

  if (!MEASUREMENT_ID) return

  if (!ReactGA.isInitialized) {
    ReactGA.initialize(MEASUREMENT_ID, { gaOptions: { cookieDomain: 'auto' } })
  }
}

export const ga4_pageViewURL = (url: URL) => {
  ReactGA.send({ hitType: 'pageview', page: url })
}

export const ga4_useTitle = (title: string) => {
  const router = useRouter()
  return useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: router.asPath, title: title })
  }, [])
}

export const ga4_event = (category: string, action: string, label?: string) => {
  if (!MEASUREMENT_ID) return
  ReactGA.event({ category, action, label })
}

export const ga4_buttonClicked = (label: string) => {
  if (!label) return
  ga4_event(GA4_BUTTON_CLICK.category, GA4_BUTTON_CLICK.action, label)
}
export const ga4_linkClicked = (label: string) => {
  if (!label) return
  ga4_event(GA4_LINK_CLICK.category, GA4_LINK_CLICK.action, label)
}

export const ga4_inputChanged = (label: string, condition: boolean) => {
  if (!label || !condition) return
  ga4_event(GA4_INPUT_CHANGE.category, GA4_INPUT_CHANGE.action, label)
}

export const ga4_cardClicked = (label: string) => {
  if (!label) return
  ga4_event(GA4_CARD_CLICK.category, GA4_CARD_CLICK.action, label)
}

export const useGa4RouterListener = (router: NextRouter) => {
  useEffect(() => {
    if (!ReactGA.isInitialized) return // Ensure GA4 is initialized

    const handleRouteChange = (url: string) => {
      ReactGA.send({ hitType: 'pageview', page: url }) // Send pageview event
    }

    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange) // Clean up listener
    }
  }, [router])
}
